import { Form, Input, InputNumber } from 'antd';
import { ReactElement } from 'react';
import styled from 'styled-components';

import { InvoiceDetail } from '../../../generated-api';

export const DetailRow = styled.div`
  display: grid;
  grid-template-columns: 70px repeat(4, minmax(75px, 1fr));
  grid-gap: 8px;
  align-items: baseline;
`;
const RowHeaderLabel = styled.div`
  font-weight: bold;
  padding-left: 4px;
`;
const InputNumberStyle = styled(InputNumber)`
  width: 100%;
`;

export function InvoiceDetailHeader(): ReactElement {
  return (
    <DetailRow>
      <RowHeaderLabel>税率</RowHeaderLabel>
      <RowHeaderLabel>税抜き金額</RowHeaderLabel>
      <RowHeaderLabel>税額</RowHeaderLabel>
      <RowHeaderLabel>税込み金額</RowHeaderLabel>
      <RowHeaderLabel>勘定科目</RowHeaderLabel>
    </DetailRow>
  );
}

type InvoiceDetailRowProps = {
  detail: InvoiceDetail;
};
function InvoiceDetailRow({ detail }: InvoiceDetailRowProps): ReactElement {
  return (
    <>
      <DetailRow>
        <Form.Item>
          <Input disabled defaultValue={`${detail.tax_percent}%`} />
        </Form.Item>
        <Form.Item>
          <InputNumberStyle disabled defaultValue={detail.amount_without_tax ?? 0} />
        </Form.Item>
        <Form.Item>
          <InputNumberStyle disabled defaultValue={detail.tax_amount} />
        </Form.Item>
        <Form.Item>
          <InputNumberStyle disabled defaultValue={detail.amount_with_tax} />
        </Form.Item>
        <Form.Item>
          <Input disabled defaultValue={detail.account ?? ''} />
        </Form.Item>
      </DetailRow>
    </>
  );
}

export default InvoiceDetailRow;
